import { useEffect } from 'react';

export function useHideZendeskWidget(isWidget) {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.setAttribute('zendesk-hidden', isWidget ? 'false' : 'true');
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.body.removeAttribute('zendesk-hidden');
      }
    };
  }, [isWidget]);
}